import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NmsDialogService } from "@nms-angular-toolkit/nms-dialog";
import { ErrorResponseHandlerService } from "@nms-ng2/app/core/services/error-response-handler/error-response-handler.service";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { OscInputData, OscManagementData } from "../osc-management-step.model";

/**
 * Serviço responsável por retornar os dados da gerência OSC.
 */
@Injectable({
    providedIn: "root"
})
export class OscManagementHttpService {
    baseUrl = "/web/topology/circuit/dwdm";

    constructor(private readonly http: HttpClient,
        private readonly errorResponseHandlerService: ErrorResponseHandlerService,
        private readonly nmsDialogService: NmsDialogService) {}

    getOscPorts(oscInputData: OscInputData): Observable<OscManagementData[]> {
        return this.http
            .post<OscManagementData[]>(`${this.baseUrl}/options/search-osc-management`, oscInputData)
            .pipe(catchError((error) => {
                this.handleError(error);
                return of([]);
            }));
    }

    private handleError(error: HttpErrorResponse): void {
        const { description, details } = this.errorResponseHandlerService.buildErrorDescriptionDetails(error.error);
        this.nmsDialogService.openDialog(
            { description: description + details, acceptLabel: "OK", bindHtml: true },
            { maxWidth: "800px" }
        );
    }

}
